import { z } from "zod";

export const RequestCodeFormSchema = z.object({
  phone: z.string().regex(/^55\d{11}$/, {
    message: "WhatsApp inválido",
  }),
});
